module.exports = __webpack_public_path__ + "static/img/xs1-7.590a537.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-7.png
// module id = 803
// module chunks = 0